import React, {Component} from "react";
import {Button, Checkbox, Layout, message, Radio, Statistic} from 'antd';

import Header from "../../components/header";
import "./exam.less"
import {
    reqAnswerPaper,
    reqCurrent,
    reqMockPaper,
    reqMyPaper,
    reqStudentPaper
} from "../../api";
import Modal from "antd/es/modal";
import Form from "antd/es/form";

const {Countdown} = Statistic; // Moment is also OK
const {confirm} = Modal;
const {Sider, Content} = Layout;

export class Exam extends Component {
    state = {
        deadline: 0,
        paper: {},
        qA: {},
        qB: {},
        qX: {},
        qCase: {},
        visible: false,
        modalText: '',
        paperNo: '',
        look: "none",
        clock:"block",
        disabled:false,
        type:'',
    };

    getPaper = async (id, paperNo) => {
        let result = "";
        let type = "";
        if (id === 'mock') {
            if (paperNo === 'none') {
                result = await reqMockPaper("MOCK");
                paperNo = result.data.testPaperNo;
            } else {
                result = await reqMyPaper(paperNo);
            }
            type = "模拟考试";
        } else if (id === 'finish') {
            const user = await reqCurrent();
            result = await reqStudentPaper(user.data.id, this.state.paperNo);
            this.setState({
                look: "inline-block",
                clock:"none",
                disabled:true
            })
        }else {
            sessionStorage.setItem("testing","ing");
            result = await reqMyPaper(paperNo);
            type = "正式考试";
        }
        this.setState({
            paper: result.data,
            qA: result.data.qa,
            qB: result.data.qb,
            qX: result.data.qx,
            qCase: result.data.qcase?result.data.qcase:"",
            paperNo: paperNo,
            deadline: result.data.endTime,
            type:type
        })
    };

    showModal = (text) => {
        let type = sessionStorage.getItem("testing");
        if (text === '退出测试'&&type==="ing") {
            sessionStorage.setItem("leavePage","none");
            document.getElementById("submit").click();
        }else {
            this.setState({
                visible: true,
                modalText: text
            });
        }
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            modalText: '',
            isImag:false,
        })
    };

    handleOk = () => {
        let text = this.state.modalText;
        if (text === '退出测试') {
            sessionStorage.clear();
            this.props.history.replace("/cover");
        }
    };

    onFinish = (event) => {
        //组织表单的默认行为
        event.preventDefault();
        let form = this.props.form;
        let {paperNo,deadline} = this.state;
        let prop = this.props;
        let time = deadline-Date.now();
        let leavePage = sessionStorage.getItem("leavePage");
        if(time<=0||leavePage==="leavePage"){
            sessionStorage.setItem("leavePage","none");
            form.validateFields(async (err, values) => {
                // console.log(values);
                if (!err) {
                    let answer = [];
                    let index = 0;
                    for (let key in values) {
                        let value = "";
                        if (values[key]) {
                            let answers = values[key];
                            let ans=''
                            if(answers instanceof Array){
                                var resArr=answers.sort();
                                for (let i = 0; i < resArr.length; i++) {
                                    ans += resArr[i];
                                    // console.log(ans);
                                    if (i < answers.length - 1) {
                                        ans += "|";
                                    }
                                }
                            }else{
                                ans=answers
                            }
                            // console.log(resArr);
                            value = ans;
                        } else {
                            value = values[key];
                        }
                        answer[index] = {
                            questionId: key,
                            answer: value
                        };
                        index++;
                    }
                    for (let i = 0; i < answer.length; i++) {
                        if(!answer[i].answer){
                            answer[i].answer = "";
                        }
                    }
                    const result = await reqAnswerPaper(paperNo, answer);
                    if (result.code === '000000') {
                        sessionStorage.setItem("totalScore", result.data.totalScore);
                        sessionStorage.setItem("paperNo", paperNo);
                        message.success("交卷成功");
                        prop.history.replace("/finish");
                    }
                }
            });
        }else {
            confirm({
                title: '确定交卷吗?',
                content: '',
                okText: '确定',
                cancelText: '取消',
                onOk() {
                    form.validateFields(async (err, values) => {
                        // console.log(values);
                        if (!err) {
                            let answer = [];
                            let index = 0;
                            for (let key in values) {
                                let value = "";
                                if (values[key]) {
                                    let answers = values[key];
                                    let ans=''
                                    if(answers instanceof Array){
                                        var resArr=answers.sort();
                                        for (let i = 0; i < resArr.length; i++) {
                                            ans += resArr[i];
                                            // console.log(ans);
                                            if (i < answers.length - 1) {
                                                ans += "|";
                                            }
                                        }
                                    }else{
                                        ans=answers
                                    }
                                    // console.log(resArr);
                                    value = ans;
                                } else {
                                    value = values[key];
                                }
                                answer[index] = {
                                    questionId: key,
                                    answer: value
                                };
                                index++;
                            }
                            for (let i = 0; i < answer.length; i++) {
                                if(!answer[i].answer){
                                    answer[i].answer = "";
                                }
                            }
                            // console.log(answer);
                            const result = await reqAnswerPaper(paperNo, answer);
                            if (result.code === '000000') {
                                sessionStorage.setItem("totalScore", result.data.totalScore);
                                sessionStorage.setItem("paperNo", paperNo);
                                message.success("交卷成功");
                                prop.history.replace("/finish");
                            }
                        }
                    });
                },
                onCancel() {
                },
            });
        }
    };

    submitForm =()=>{
        document.getElementById("submit").click();
    };

    toCover = ()=> {
        sessionStorage.clear();
        this.props.history.replace("/cover");
    };

    maxPic = (pics)=> {
        Modal.info({
            title: '',
            width:'40%',
            okText:'关闭',
            icon:'none',
            className:'pic',
            content: (
                <div>
                    <img style={{width:"100%",height:"auto"}} src={global.constant.uploadImage + pics[0]} />
                </div>
            ),
            onOk() {},
        });
    };

    componentDidMount = async () => {
        let pid = sessionStorage.getItem("pid");
        let paperNo = sessionStorage.getItem("paperNo");
        this.setState({
            pid: pid,
            paperNo: paperNo
        });
        this.getPaper(pid, paperNo);
    };

    render() {

        const {getFieldDecorator} = this.props.form;
        const self = this;
        const {qA, qB, qX, qCase, paper, modalText, visible,look,deadline,disabled,clock} = this.state;

        return (
            <Layout style={{height: '100%'}}>
                <Header>Header</Header>
                <Layout>
                    <Sider>
                        <div className='clock' style={{display:clock}}>
                            <div style={{float: 'left'}}>
                                <img src={require("./images/icon-clock.png")}/>
                            </div>
                            <div style={{float: 'right', marginRight: 70}}>
                                <Countdown value={deadline} format="mm:ss" onFinish={this.submitForm}/>
                            </div>
                        </div>
                    </Sider>
                    <Content>
                        <div className='exam'>
                            <Form onSubmit={this.onFinish}>
                                <div className='all_num'>
                                    <div>
                                        <div className='count'>共{paper.total}题</div>
                                        <div
                                            className='list_desc'>一、A型题：本题共{qA.total}小题，每小题{qA.scorePer}分,共{qA.total * qA.scorePer}分，在每题给出的所有选项中，只有1个正确选项。
                                        </div>
                                        {
                                            qA.questions && qA.questions.map(function (item, index) {
                                                return (
                                                    <div key={index}>
                                                        {
                                                            item.questions && item.questions.map(function (ques, ins) {
                                                                return (
                                                                    <div key={ins}>
                                                                        <div id={ques.id}
                                                                             className='list_title'>
                                                                            <span
                                                                                className='exam_index'>第{1 + index}题</span>{ques.question}：
                                                                        </div>
                                                                        <Form.Item>
                                                                            {getFieldDecorator('' + ques.id, {
                                                                                initialValue: ques.answer,
                                                                            })(
                                                                                <Radio.Group className='list_radio'>
                                                                                    {
                                                                                        item.options && item.options.map(function (order, i) {
                                                                                            return (
                                                                                                <Radio disabled={disabled}
                                                                                                    value={order.optionKey}
                                                                                                    key={i}>
                                                                                                    {order.optionKey} {order.optionValue}
                                                                                                </Radio>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </Radio.Group>)}
                                                                        </Form.Item>
                                                                        <div className='list_img' >
                                                                            <img onClick={self.maxPic.bind(self,item.imgs)} style={{cursor:'pointer'}}
                                                                                src={item.imgs && global.constant.uploadImage + item.imgs[0]} />
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    <div>
                                        <div
                                            className='list_desc'>二、B型题：本题共{qB.total}小题，每小题{qB.scorePer}分,共{qB.total * qB.scorePer}分，在每题给出的所有选项中，只有1个正确选项。
                                        </div>
                                        {
                                            qB.questions && qB.questions.map(function (item, index) {
                                                return (
                                                    <div key={index}>
                                                        {
                                                            item.questions && item.questions.map(function (second, or) {
                                                                return (
                                                                    <div key={or}
                                                                         className='list_title'>{1 + or}.{second.question}：
                                                                        <span style={{marginLeft: 30}}>
                                                                        <Form.Item>
                                                                            {getFieldDecorator('' + second.id, {
                                                                                initialValue: second.answer
                                                                            })(
                                                                                <Radio.Group className='list_option'
                                                                                             id={item.id}>
                                                                                    {
                                                                                        item.options && item.options.map(function (order, i) {
                                                                                            return (
                                                                                                <Radio disabled={disabled}
                                                                                                    value={order.optionKey}
                                                                                                    key={i}>
                                                                                                    {order.optionKey}
                                                                                                </Radio>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </Radio.Group>)}
                                                                        </Form.Item>
                                                                        </span>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div className='list_opt'>
                                                            {
                                                                item.options && item.options.map(function (opt, j) {
                                                                    return (
                                                                        <div key={j}>
                                                                            {opt.optionKey}、{opt.optionValue}
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                        <div className='list_img type_B' >
                                                            <img onClick={self.maxPic.bind(self,item.imgs)} style={{cursor:'pointer'}}
                                                                src={item.imgs && global.constant.uploadImage + item.imgs[0]} />
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    <div>
                                        <div
                                            className='list_desc'>三、X型题：本题共{qX.total}小题，每小题{qX.scorePer}分,共{qX.total * qX.scorePer}分，在每题给出的所有选项中，有2个或2个以上正确选项。
                                        </div>
                                        {
                                            qX.questions && qX.questions.map(function (item, index) {
                                                return (
                                                    <div key={index}>
                                                        {
                                                            item.questions && item.questions.map(function (ques, ins) {
                                                                return (
                                                                    <div key={ins}>
                                                                        <div id={ques.id}
                                                                             className='list_title'>
                                                                            {1 + index}. {ques.question}：
                                                                        </div>
                                                                        <Form.Item>
                                                                            {getFieldDecorator('' + ques.id, {
                                                                                initialValue: ques.answer&&ques.answer.split("|"),
                                                                            })(
                                                                                <Checkbox.Group
                                                                                    className='list_checkbox'>
                                                                                    {
                                                                                        item.options && item.options.map(function (order, i) {
                                                                                            return (
                                                                                                <Checkbox disabled={disabled}
                                                                                                    value={order.optionKey}
                                                                                                    key={i}>
                                                                                                    {order.optionKey} {order.optionValue}
                                                                                                </Checkbox>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </Checkbox.Group>)}
                                                                        </Form.Item>
                                                                        <div className='list_img' >
                                                                            <img onClick={self.maxPic.bind(self,item.imgs)} style={{cursor:'pointer'}}
                                                                                src={item.imgs && global.constant.uploadImage + item.imgs[0]}/>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                                <div className='all_num'>
                                    <div className='ill_title'>
                                        <div className='case_title'>{qCase.title}</div>
                                        <div>{qCase.description}</div>
                                    </div>
                                    <div>
                                        {
                                            qCase.questions && qCase.questions.map(function (item, index) {
                                                return (
                                                    <div key={index}>
                                                        {
                                                            item.questions && item.questions.map(function (ques, ins) {
                                                                return (
                                                                    <div key={ins}>
                                                                        <div id={ques.id}
                                                                             className='list_title ill_con'>
                                                                        <span
                                                                            style={{fontWeight: 'bold'}}>第{index + 1}题</span> {ques.question}：
                                                                        </div>
                                                                        <Form.Item>
                                                                            {getFieldDecorator('' + ques.id, {
                                                                                initialValue: ques.answer&&ques.answer.split("|"),
                                                                            })(
                                                                                <Checkbox.Group
                                                                                    className='list_checkbox'>
                                                                                    {
                                                                                        item.options && item.options.map(function (order, i) {
                                                                                            return (
                                                                                                <Checkbox disabled={disabled}
                                                                                                    value={order.optionKey}
                                                                                                    key={i}>
                                                                                                    <span
                                                                                                        className='list_circle'>{order.optionKey}</span>{order.optionValue}
                                                                                                </Checkbox>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </Checkbox.Group>)}
                                                                        </Form.Item>
                                                                        <div className='list_img'>
                                                                            <img onClick={self.maxPic.bind(self,item.imgs)} style={{cursor:'pointer'}}
                                                                                src={item.imgs && global.constant.uploadImage + item.imgs[0]} />
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                                {
                                    look==='none'?
                                    <div className='bottom_btn'>
                                    <button type={"button"} className='gray' onClick={this.showModal.bind(this, '退出测试')}>退出测试</button>
                                    <Form.Item>
                                    <Button className='blue' htmlType="submit" id='submit'>交卷</Button>
                                    </Form.Item>
                                    </div>:<button type={"button"} className='onExit' onClick={this.toCover.bind(this)}>退出</button>
                                }
                            </Form>
                        </div>
                        <Modal title={modalText} visible={visible} className='exam_modal' width={280}
                               onOk={this.handleOk}
                               onCancel={this.handleCancel}
                               okText="确认"
                               cancelText="取消">
                            <div>确定{modalText}吗?</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrappedExam = Form.create()(Exam);
export default WrappedExam;